import getParent, { getParentAttribute } from "../../utils/getParent";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { getAttribute, getFilter } from "./get";
/**
 * 专题点击
 * @param {Element} targetNode
 */
export function topic_click(targetNode) {
  const page = getPage();
  const filter = getFilter(page.page_nm);

  const trackData = {
    event_id: 35004,
    event: "topic_click",
    topic_id:
      targetNode.getAttribute("data-topic-id") ||
      getParentAttribute(targetNode, "data-topic-id"),
    topic_title:
      targetNode.getAttribute("data-topic-title") ||
      getParentAttribute(targetNode, "data-topic-title"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    const topic_type = getAttribute(targetNode, "data-topic-type");
    if (topic_type) {
      trackData.topic_type = topic_type;
    }
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.topic_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }_${sourceNode.getAttribute("data-content-source")}`;
    } else {
      trackData.topic_source = `${page_nm}_${
        sub_page_nm || ""
      }_${sourceNode.getAttribute("data-content-source")}`;
    }
  } else {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.topic_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }`;
    } else {
      trackData.topic_source = `${page_nm}_${sub_page_nm || ""}`;
    }
  }
  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  reporter(trackData);
}
